import React from 'react';
import { useHistory } from 'react-router-dom';
import ButtonDialog from 'components/button-dialog';
import styles from 'feature/license-plates/index.module.scss';
import { useLicensePlateContext, CLOSE_DIALOG } from 'feature/license-plates/use-license-plate';
import { vehicleCarTypes } from 'feature/license-plates/license-plate-item';
import { useAppContext } from 'use-app';
import amplitude from 'service/amplitude';
import { getUserInfo } from 'helpers/data-check-helper';
import { isLineBank, config } from 'config';
import { ENERGY_SOURCE } from "model/energy-source";

const LicensePlateDialog = ({ isShow = false, licensePlate }) => {
  const { state, dispatch, deleteLicensePlate, bindLicensePlate } = useLicensePlateContext();
  const { state: appState } = useAppContext();
  const { hasPayments } = getUserInfo(appState);
  const history = useHistory();

  const editPlateNumber = () => {
    amplitude.plateNumber_window_edit_onClick();
    if (isLineBank) {
      return (window.location.href = config.lineBankLicensePlatesPage);
    }
    const energySourceQs = !licensePlate.energySource ? '' : `&energySource=${licensePlate.energySource}`;

    history.push(
      `/license-plates/${licensePlate.id}/edit?plateNumber=${licensePlate.plateNumber}&vehicleType=${licensePlate.vehicleType}${energySourceQs}`
    );
  };

  const deletePlateNumber = () => {
    amplitude.plateNumber_window_delete_onClick();
    deleteLicensePlate({ payload: licensePlate });
  };

  const closeDialog = () => {
    amplitude.plateNumber_window_cancel_onClick();
    dispatch({ type: CLOSE_DIALOG });
  };

  const bindPlateNumber = () => {
    amplitude.plateNumber_window_rebind_onClick();
    bindLicensePlate(licensePlate.id);
  };

  const taipeiCityParkinglotBinding = bindingState => {
    if (bindingState === 'processing') {
      return (
        <div className={styles['taipei-city-parkinglot-binding']}>
          北市公有停車場車牌等待綁定中，需等待綁定完成後，隔日凌晨 4:00 起，才可使用車牌辨識自動繳費功能。
        </div>
      );
    } else if (bindingState === 'binding_failed') {
      if (hasPayments) {
        return (
          <div className={styles['taipei-city-parkinglot-binding']}>
            北市公有停車場車牌綁定失敗，請先移除其他平台車號設定後，點此重新綁定。
          </div>
        );
      } else {
        return (
          <div className={styles['taipei-city-parkinglot-binding']}>
            北市公有停車場車牌綁定失敗，請先設定您的付款方式。
          </div>
        );
      }
    } else {
      return null;
    }
  };

  const dialogItems = bindingState => {
    let items = [];

    if (bindingState === 'binding_failed' && hasPayments) {
      items = items.concat([
        {
          content: '重新綁定',
          theme: 'positive',
          onClick: bindPlateNumber,
        },
      ]);
    }

    if (isLineBank) {
      items = items.concat([
        {
          content: '修改車牌',
          theme: 'positive',
          onClick: editPlateNumber,
        },
        {
          content: '取消',
          theme: 'cancel',
          onClick: closeDialog,
        },
      ]);
    } else {
      items = items.concat([
        {
          content: '修改車牌',
          theme: 'positive',
          onClick: editPlateNumber,
        },
        {
          content: '刪除車牌',
          theme: 'negative',
          onClick: deletePlateNumber,
          beLoading: true,
        },
        {
          content: '取消',
          theme: 'cancel',
          onClick: closeDialog,
        },
      ]);
    }

    return items;
  };

  const energySourceText = licensePlate.energySource ? ` / ${ENERGY_SOURCE[licensePlate.energySource].value}` : ''

  return (
    <ButtonDialog
      title={`${licensePlate.plateNumber} / ${vehicleCarTypes[licensePlate.vehicleType]}${energySourceText}`}
      items={dialogItems(state.bindingState)}
      isShow={isShow}
    >
      {taipeiCityParkinglotBinding(state.bindingState)}
    </ButtonDialog>
  );
};

export default LicensePlateDialog;
